<div class="timeline">
  @for (paymentMoment of paymentsOverview; track paymentMoment; let isFirst = $first; let isLast = $last) {
    <div class="timeline__item">
      <!-- Timeline connector -->
      <div class="timeline__connector">
        <div class="timeline__line timeline__line--top" [class.timeline__line--hidden]="isFirst"></div>
        <div class="timeline__dot">
          <i class="fa fa-calendar-alt"></i>
        </div>
        <div class="timeline__line timeline__line--bottom" [class.timeline__line--hidden]="isLast"></div>
      </div>

      <!-- Timeline content -->
      <div class="timeline__content" (click)="onSelectAllowanceItem(paymentMoment)" (keyup.enter)="onSelectAllowanceItem(paymentMoment)" role="button" tabindex="0">
        <!-- Header: Unemployment Month + Document Type + Unemployment Type -->
        <div class="timeline__header">
          <div class="timeline__month">
            {{paymentMoment?.unemploymentMonth | date:'MM/yyyy'}}
          </div>
          <div class="timeline__header-right">
            <span class="timeline__doc-badge">
              {{paymentMoment?.mainDocumentType | uppercase}}
            </span>
            @if (getTranslatedData(paymentMoment?.unemploymentTypeDescription)) {
              <span class="timeline__type-badge">
                {{getTranslatedData(paymentMoment?.unemploymentTypeDescription)}}
              </span>
            }
          </div>
        </div>

        <!-- Body -->
        <div class="timeline__body">
          <!-- Payment Date -->
          <div class="timeline__payment-date">
            <i class="fa fa-euro-sign"></i>
            <span>{{ 'ALLOWANCES.OVERVIEW.LIST.date_payment' | translate }}: {{paymentMoment?.dateOfPayment | date:'dd/MM/yyyy'}}</span>
          </div>

          <!-- Amounts -->
          <div class="timeline__amounts">
            <div class="timeline__amount-block">
              <span class="timeline__amount-label">{{ 'ALLOWANCES.OVERVIEW.LIST.amount_unemployment' | translate }}</span>
              <div class="timeline__amount-value timeline__amount-value--primary">
                {{getCurrency('E')}} {{sumUnemploymentGrossAmount(paymentMoment)}}@if (paymentMoment?.mainDocumentType !== 'C131.B') {<span class="timeline__amount-days">({{sumUnemploymentDays(paymentMoment)}} {{'FINANCIAL.days_short' | translate}})</span>}
              </div>
            </div>

            @if (sumAdditionalCompensationGrossAmount(paymentMoment) && sumAdditionalCompensationGrossAmount(paymentMoment) !== '0,00') {
              <div class="timeline__amount-block">
                <span class="timeline__amount-label">{{ 'ALLOWANCES.OVERVIEW.LIST.additional_compensation_short' | translate }}</span>
                <div class="timeline__amount-value">
                  {{getCurrency('E')}} {{sumAdditionalCompensationGrossAmount(paymentMoment)}}@if (paymentMoment?.mainDocumentType !== 'C131.B') {<span class="timeline__amount-days">({{sumAdditionalCompensationDays(paymentMoment)}} {{'FINANCIAL.days_short' | translate}})</span>}
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Footer -->
        <div class="timeline__footer">
          <span class="timeline__institution">
            {{getTranslatedData(paymentMoment?.paymentOfficeDescription)}}
          </span>
          <i class="fa fa-chevron-right timeline__arrow"></i>
        </div>
      </div>
    </div>
  }
</div>
